import { render } from "./NAttachments.vue?vue&type=template&id=3edbd330&ts=true"
import script from "./NAttachments.vue?vue&type=script&lang=ts"
export * from "./NAttachments.vue?vue&type=script&lang=ts"

import "./NAttachments.vue?vue&type=style&index=0&id=3edbd330&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__